import {
  PreviewServiceIcon,
  PreviewVehicleIcon,
  PreviewDateIcon,
  PreviewMileageIcon,
} from "./LatestServicesPreviewIcons";
import {
  formatJalaliDate,
  formatMileage,
} from "../../LatestServices/components/jalaliUtils";

function LatestServiceItem({ service, vehicleName }) {
  const title = service?.displayType || "سرویس";
  const dateStr = formatJalaliDate(service?.serviceDate);
  const mileageStr =
    service?.mileage === null ||
    service?.mileage === undefined ||
    service?.mileage === ""
      ? null
      : `${formatMileage(service.mileage)} کیلومتر`;

  return (
    <li className="LatestServiceItem" dir="rtl">
      <span className="LatestServiceItem__icon" aria-hidden>
        <PreviewServiceIcon />
      </span>
      <div className="LatestServiceItem__content">
        <p className="LatestServiceItem__title">{title}</p>
        <div className="LatestServiceItem__meta">
          {vehicleName && (
            <span className="LatestServiceItem__meta-item">
              <PreviewVehicleIcon />
              {vehicleName}
            </span>
          )}
          <span className="LatestServiceItem__meta-item">
            <PreviewDateIcon />
            {dateStr}
          </span>
          {mileageStr && (
            <span className="LatestServiceItem__meta-item">
              <PreviewMileageIcon />
              {mileageStr}
            </span>
          )}
        </div>
      </div>
    </li>
  );
}

export default LatestServiceItem;
